'use client' // Error boundaries must be Client Components

import { logger } from './utilities/logger'
import Link from 'next/link'
import { useEffect } from 'react'

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    useEffect(() => {
        logger.error('Global Error Boundary caught an error', error, { digest: error.digest })
    }, [error])

    return (
        <>
            <title>500 - Server Error</title>
            <meta name="description" content="We're sorry, something went wrong on our end. Please try again in a few minutes." />
            <meta name="robots" content="noindex, noarchive, nofollow" />
            <meta name="keywords" content="500 - Server Error" />
            <meta name="author" content="MyCarJunction" />

            <div className="flex min-h-70 flex-col items-center justify-center px-4">
                <div className="max-w-md w-full  p-8 text-center">
                    <h2 className="text-2xl font-bold text-red-600 mb-4">
                        Something went wrong!
                    </h2>
                    <p className="text-gray-600 mb-6">
                        We encountered an unexpected error. Please try again or return to the home page.
                    </p>
                    <div className="flex gap-4 justify-center">
                        <button
                            onClick={reset}
                            className="px-5 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 transition"
                        >
                            Try Again
                        </button>
                        <Link
                            href="/"
                            className="px-5 py-2 rounded-lg bg-gray-200 text-gray-800 hover:bg-gray-300 transition"
                            prefetch={false}
                        >
                            Go Home
                        </Link>
                    </div>
                </div>
            </div>
        </>
    )
}
